<template>
    <page>
        <module title="会员礼包详情">
            <div v-if="giftPackage">
                <c-detail title="基础信息">
                    <c-detail-item label="礼包名称">{{giftPackage.name}}</c-detail-item>

                    <c-detail-item label="礼包价值">{{giftPackage.total_price.toFixed(2)}}元</c-detail-item>

                    <c-detail-item label="礼包海报" full>
                        <div  v-if="giftPackage.gift_img_list" class="flex-center-cross">
                            <c-image  v-for="(item, i) in giftPackage.gift_img_list" :src="item" size="120" preview></c-image>
                        </div>
                        <span v-else>未上传</span>
                    </c-detail-item>

                    <c-detail-item label="备注">{{giftPackage.remark}}</c-detail-item>

                    <c-detail-item label="礼包商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="200"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="商品规格"
                                    name="product_sku_spec"
                                    width="100"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="SKU编码"
                                    name="product_sku_code"
                                    width="100"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="日常售价"
                                    name="product_price"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{parseFloat(data.product_price).toFixed(2)}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="数量"
                                    name="gift_count"
                                    width="80"
                            ></c-table-column>

                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'gift_package_detail',

        props: {
            id: String
        },

        data() {
            return {
                giftPackage: '',
                productList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/gift_package/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.giftPackage = data;
                        this.productList = data.giftPackageProductList;
                    }
                });
            }
        }
    }
</script>